import { render, staticRenderFns } from "./LiveAssistantHeader.vue?vue&type=template&id=43121ea9&scoped=true"
import script from "./LiveAssistantHeader.vue?vue&type=script&lang=js"
export * from "./LiveAssistantHeader.vue?vue&type=script&lang=js"
import style0 from "./LiveAssistantHeader.vue?vue&type=style&index=0&id=43121ea9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43121ea9",
  null
  
)

export default component.exports